// Lista que define la creación automática de rutas
const rutasMaestroDetalle = [
  {
    path: "clasdiag_diagnostico/:p_idclasdiag",
    name: "ClasDiag_Diagnostico",
    component: "ClasDiag_Diagnostico",
  },
  {
    path: "claselem_elemento/:p_idclaselem",
    name: "ClasElem_Elemento",
    component: "ClasElem_Elemento",
  },
  {
    path: "diagnostico_diagaten/:p_iddiagnostico",
    name: "Diagnostico_DiagAten",
    component: "Diagnostico_DiagAten",
  },
  {
    path: "empresa_horario/:p_idempresa",
    name: "Empresa_Horario",
    component: "Empresa_Horario",
  },
  {
    path: "empresa_empresaimg/:p_idempresa",
    name: "Empresa_EmpresaImg",
    component: "Empresa_EmpresaImg",
  },
  {
    path: "empresa_persona/:p_idempresa",
    name: "Empresa_Persona",
    component: "Empresa_Persona",
  },
  {
    path: "empresa_usuario/:p_idempresa",
    name: "Empresa_Usuario",
    component: "Empresa_Usuario",
  },
  {
    path: "empresa_medioemp/:p_idempresa",
    name: "Empresa_MedioEmp",
    component: "Empresa_MedioEmp",
  },
  {
    path: "empresa_paremp/:p_idempresa",
    name: "Empresa_ParEmp",
    component: "Empresa_ParEmp",
  },
  {
    path: "especialidad_medico/:p_idespecialidad",
    name: "Especialidad_Medico",
    component: "Especialidad_Medico",
  },
  {
    path: "factura_facturadet/:p_idfactura",
    name: "Factura_FacturaDet",
    component: "Factura_FacturaDet",
  },
  {
    path: "formapago_suscripcion/:p_idformapago",
    name: "FormaPago_Suscripcion",
    component: "FormaPago_Suscripcion",
  },
  {
    path: "localidad_empresa/:p_idlocalidad",
    name: "Localidad_Empresa",
    component: "Localidad_Empresa",
  },
  {
    path: "localidad_persona/:p_idlocalidad",
    name: "Localidad_Persona",
    component: "Localidad_Persona",
  },
  {
    path: "perfil_usuario/:p_idperfil",
    name: "Perfil_Usuario",
    component: "Perfil_Usuario",
  },
  {
    path: "persona_medico/:p_idpersona",
    name: "Persona_Medico",
    component: "Persona_Medico",
  },
  {
    path: "planilladet_pladetobs",
    name: "PlanillaDet_PlaDetObs",
    component: "PlanillaDet_PlaDetObs",
  },
  {
    path: "cargaplanilla_cargaplanilladet/:p_idcargaplanilla",
    name: "CargaPlanilla_CargaPlanillaDet",
    component: "CargaPlanilla_CargaPlanillaDet",
  },
  {
    path: "especialidad_espepres/:p_idespecialidad",
    name: "Especialidad_EspePres",
    component: "Especialidad_EspePres",
  },
  {
    path: "elemento_elempres/:p_idelemento",
    name: "Elemento_ElemPres",
    component: "Elemento_ElemPres",
  },
  {
    path: "elemento_tarifapres/:p_idelemento",
    name: "Elemento_TarifaPres",
    component: "Elemento_TarifaPres",
  },
  {
    path: "prestador_elempres/:p_idprestador",
    name: "Prestador_ElemPres",
    component: "Prestador_ElemPres",
  },
  {
    path: "elempres_elemequi/:p_idelempres",
    name: "ElemPres_ElemEqui",
    component: "ElemPres_ElemEqui",
  },
  {
    path: "plantilla_plantilladet/:p_idplantilla",
    name: "Plantilla_PlantillaDet",
    component: "Plantilla_PlantillaDet",
  },
  {
    path: "asegurador-clasaseg/:p_idasegurador",
    name: "Asegurador_ClasAseg",
    component: "Asegurador_ClasAseg",
  },
];

// Función que genera las rutas utilizando importación dinámica
const rutas = rutasMaestroDetalle.map(({ path, name, component }) => ({
  path: `/${path}`,
  name,
  component: () => import(`../views/masterDetails/${component}.vue`),
}));

export default rutas;
